import { AnalyticalExaminationType } from '@dreryk/drerykweb-medical-dictionaries-api';
import { ReferralToAnalyticalExaminationCreateOrUpdateDetails } from '@dreryk/egabinet-referral-frontend-api';

import { Slot } from '@dreryk/watermelon';

import { ReferralToAnalyticalExaminationFormBean } from '../ReferralToAnalyticalExaminationForm/ReferralToAnalyticalExaminationForm.types';

export const mapReferralToAnalyticalExaminationFormBeanToReferralCommandDetails = (
   formData: ReferralToAnalyticalExaminationFormBean
): ReferralToAnalyticalExaminationCreateOrUpdateDetails => {
   const referralDetails = new ReferralToAnalyticalExaminationCreateOrUpdateDetails();

   referralDetails.additionalInformation = Slot.emptyIfNull(formData.additionalInformation);
   referralDetails.analyticalExaminationTypeIds = formData.analyticalExaminationTypes.map(
      (examination: AnalyticalExaminationType) => examination.id
   );

   return referralDetails;
};
